var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.getTab == 1)?_c('MonthlyReportTable'):_vm._e(),(_vm.getTab == 2)?_c('DetailReportTable'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }